var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FilterBaseInputTextMatchType',{staticClass:"filter-landing-page-title-form",attrs:{"value":_vm.pageTitle,"match-method":_vm.matchMethod,"input-form-suggestion-type":_vm.inputFormSuggestionType,"data-cy":"filter-landing-page-title-form"},on:{"input-text":_vm.onInputText,"input-match-method":_vm.onInputMatchMethod}})
}
var staticRenderFns = []

export { render, staticRenderFns }